<template>
  <div>
    <div class="form-group">
      <label class="col-xs-2 control-label">
        <slot name="label">
        {{label}}
        </slot>
        <span class="label label-danger" v-if="showRequire===true">必須</span>
      </label>
      <div class="col-xs-10">
        <slot name="text">
          <input v-if="readonly" readonly="" type="text" class="form-control" :value="val">
          <input v-if="!readonly" type="text" class="form-control" :value="val" v-on:input="onInput" :maxlength="maxLength">
          <slot name="message"></slot>
        </slot>
      </div>
    </div>
    <slot name="line">
      <line-dashed></line-dashed>
    </slot>
  </div>
</template>
<script>
  export default {
    props: [
      'label',
      'maxLength',
      'val',
      'readonly',
      'message',
      'hr',
      'require'
    ],
    data: function () {
      return {
        showRequire: this.require
      }
    },
    methods: {
      onInput (e) {
        // 親のv-bindを更新
        // 初期値を設定とかするために
        // v-model="company.company_name" :input="company.company_name"
        // とかしないといけないのか・・・？
        this.$emit('input', e.target.value)
      }
    }
  }
</script>




// WEBPACK FOOTER //
// TextGroup.vue?d6ae13cc